import { queryOptions } from '@tanstack/react-query';
import { QUERY_KEYS, STALE_TIME_SHORT } from '@/app/api/constants.ts';
import { fetchMediation } from '@/entities/mediation/api/requests.ts';
import { authStore } from '@/app/localStorage/utils.ts';

export const fetchMediationOptions = ({
  mediationId,
}: {
  mediationId: number;
}) => {
  const token = authStore.getToken();
  return queryOptions({
    queryKey: [QUERY_KEYS.FETCH_MEDIATION, mediationId, token],
    queryFn: () => fetchMediation({ mediationId }),
    staleTime: STALE_TIME_SHORT,
    refetchOnWindowFocus: true,
    enabled: !!token,
  });
};
